import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/accordion'
import { Box, Flex, Link, VStack } from '@chakra-ui/layout'
import { Icon, Text as ChakraText } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { RiCropLine } from 'react-icons/ri'

const DocumentationImageTransformation = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <AccordionItem>
      <AccordionButton px={12} py={8}>
        <Flex flex="1" textAlign="left" fontWeight="bold">
          <Icon as={RiCropLine} boxSize={6} mr={4} />

          {t('support_image_transformation')}
        </Flex>
        <Box background="appPaleGreyThree" borderRadius="full" padding={1}>
          <AccordionIcon color="appSlate" display="block" />
        </Box>
      </AccordionButton>

      <AccordionPanel px={12} py={8}>
        <VStack spacing={3}>
          <Flex direction="column" width="100%">
            <ChakraText fontWeight="semibold" mb={8}>
              {t('support_resize_crop')}
            </ChakraText>
            <ChakraText mb={4}>
              {t('support_resize_crop_description')}
            </ChakraText>
            <Link
              isExternal
              href="https://docs.imagekit.io/features/image-transformations/resize-crop-and-other-transformations#basic-image-resizing"
            >
              {t('support_basic_image_resizing')}
            </Link>
            <Link
              isExternal
              href="https://docs.imagekit.io/features/image-transformations/resize-crop-and-other-transformations#crop-crop-modes-and-focus"
            >
              {t('support_crop_crop_modes')}
            </Link>
            <Link
              isExternal
              href="https://docs.imagekit.io/features/image-transformations/resize-crop-and-other-transformations#commonly-used-transformations"
            >
              {t('support_commonly_used_transformation')}
            </Link>
          </Flex>
        </VStack>
      </AccordionPanel>
    </AccordionItem>
  )
}

export default DocumentationImageTransformation
